import { Alert } from "@cmsgov/ds-medicare-gov";
import React from "react";
import { Link } from "react-router-dom";
import { Routes } from "../app";
import { useTranslate } from "../helpers";

export const DuplicatePrescriptionNotification: React.FC<{
  linkPrescriptionList?: boolean;
  className?: string;
}> = ({ linkPrescriptionList = false, className = "" }) => {
  const t = useTranslate();
  return (
    <Alert variation="warn" role="alert" hideIcon={true} className={className}>
      {t("prescription.error.duplicate_prescription_notification")}
      {linkPrescriptionList && (
        <span>
          &nbsp;
          <Link to={Routes.prescriptionsList}>
            {t("prescription.remove_extra_drug")}
          </Link>
        </span>
      )}
    </Alert>
  );
};
